export default {
  USER_SIGN_UP(state, payload) {
    state[payload.key] = payload.value;
  },
  USER_LOGIN(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_AGREEMENT_STATUS(state, payload) {
    state[payload.key] = payload.value;
  },
  USER_MODULES(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_ALL_MODULES(state, payload) {
    state.allModules = payload;
  },
  USER_ROLES(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_PLAN(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_MY_ADDONS(state, payload) {
    state[payload.key] = payload.value;
  },
};
